import { TextField, Button, CircularProgress, Divider } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { API_URL } from '../../constants';
export default function Profile() {

    const auth = useSelector(state => state.auth);
    const userID = auth.userId

    const [userReq, setUserReq] = useState('')
    useEffect(() => {
        axios.get(`${API_URL}/users/${userID}`).then(
            res => {
                setUserReq(res.data)
            }
        )
    }, [])

    return (
        <div className="main_frame">

            <div className="main_frame_container">
                <div className="folder_card_2">
                    <div className="card_header" >

                        changer le mot de passe
                    </div>

                    {
                        userReq.user !== undefined ?
                            <div className="profile_form">

                                <TextField label='nom' value={userReq.user.fullname} variant="outlined" disabled />
                                <TextField label="adresse e-maile" value={userReq.user.email} v variant="outlined" disabled />
                                <TextField label="numéro de téléphone" variant="outlined" value={userReq.user.phone} v disabled />
                                <TextField label="password actuel" type="password" variant="outlined" />
                                <Divider />
                                <TextField label="nouveau mot de passe" type="password" variant="outlined" />
                                <TextField label="confirmer le mot de passe" type="password" variant="outlined" />
                                <Button style={{ color: '#1572B4', fontWeight: 'bold', borderColor: '#1572B4', borderRadius: '24px' }} variant={'outlined'}>enregistrer</Button>
                            </div> : <div className="is_Loading" >
                                <CircularProgress size={50} thickness={4} />
                            </div>
                    }


                </div>

            </div>

        </div>
    )
}
